import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const getWeekdaysAction = createAsyncThunk(`${companySliceName}/getWeekdays`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/weekday/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});